import React from "react";
import { Space } from "antd";
import { AxSlider, AxInputNumber, AxDivider, AxButton } from "@dynata/axiom3";

// const marks = {
//   0: "0",
//   25: "25",
//   50: "50",
//   75: "75",
//   100: "100",
// };
// const [value, setValue] = useState(30);
// const handleInputChange = (value) => {
//   setValue(value);
// };

class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      range: [5, 10],
    };
  }
  render() {
    return (
      <div className="section" id="slider">
        <h3>Slider</h3>
        <p>
          A Slider component for displaying current value and intervals in
          range.
        </p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxSlider defaultValue={50} />`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/slider/#API"
                >
                  https://ant.design/components/slider/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>autoFocus</td>
                  <td>Whether get focus when component mounted</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultValue</td>
                  <td>
                    The default value of slider. When <code>range</code> is
                    false, use number, otherwise, use [number, number]
                  </td>
                  <td>number | [number, number]</td>
                  <td>0 | [0, 0]</td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>If true, the slider will not be interactable</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>dots</td>
                  <td>Whether the thumb can drag over tick only</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>included</td>
                  <td>
                    Make effect when <code>marks</code> not null, true means
                    containment and false means coordinative
                  </td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>marks</td>
                  <td>
                    Tick mark of Slider, type of key must be <code>number</code>
                    , and must in closed interval [min, max], each mark can
                    declare its own style
                  </td>
                  <td>object</td>
                  <td>
                    <pre>{`{ number: ReactNode } | { number: { style: CSSProperties, label: ReactNode } }`}</pre>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>max</td>
                  <td>The maximum value the slider can slide to</td>
                  <td>number</td>
                  <td>100</td>
                  <td></td>
                </tr>
                <tr>
                  <td>min</td>
                  <td>The minimum value the slider can slide to</td>
                  <td>number</td>
                  <td>0</td>
                  <td></td>
                </tr>
                <tr>
                  <td>range</td>
                  <td>Dual thumb mode</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>reverse</td>
                  <td>Reverse the component</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>step</td>
                  <td>
                    The granularity the slider can step through values. Must
                    greater than 0, and be divided by (max - min) . When{" "}
                    <code>marks</code> no null, <code>step</code> can be null
                  </td>
                  <td>number | null</td>
                  <td>1</td>
                  <td></td>
                </tr>
                <tr>
                  <td>tooltip</td>
                  <td>The tooltip relate props</td>
                  <td>
                    <a href="#tooltip">tooltip</a>
                  </td>
                  <td>-</td>
                  <td>4.23.0</td>
                </tr>
                <tr>
                  <td>value</td>
                  <td>
                    The value of slider. When <code>range</code> is false, use
                    number, otherwise, use [number, number]
                  </td>
                  <td>number | [number, number]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>vertical</td>
                  <td>If true, the slider will be vertical</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onAfterChange</td>
                  <td>Fire when onmouseup is fired</td>
                  <td>(value) =&gt; void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>
                    Callback function that is fired when the user changes the
                    slider's value
                  </td>
                  <td>(value) =&gt; void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>trackStyle</td>
                  <td>The style of slider track</td>
                  <td>CSSProperties</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>handleStyle</td>
                  <td>The style of slider handle</td>
                  <td>CSSProperties</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/slider/#API"
                      >
                        {`<Slider />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className="prop-header">
              <p className="props-title">Range</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>draggableTrack</td>
                  <td>Whether range track can be drag</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td>4.10.0</td>
                </tr>
              </tbody>
            </table>
            <div className="prop-header">
              <p className="props-title">tooltip</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>open</td>
                  <td>
                    If true, Tooltip will show always, or it will not show
                    anyway, even if dragging or hovering
                  </td>
                  <td>boolean</td>
                  <td>-</td>
                  <td>4.23.0</td>
                </tr>
                <tr>
                  <td>placement</td>
                  <td>
                    Set Tooltip display position. Ref{" "}
                    <a href="/components/tooltip/">Tooltip</a>
                  </td>
                  <td>string</td>
                  <td>-</td>
                  <td>4.23.0</td>
                </tr>
                <tr>
                  <td>getPopupContainer</td>
                  <td>
                    The DOM container of the Tooltip, the default behavior is to
                    create a div element in body
                  </td>
                  <td>(triggerNode) =&gt; HTMLElement</td>
                  <td>() =&gt; document.body</td>
                  <td>4.23.0</td>
                </tr>
                <tr>
                  <td>formatter</td>
                  <td>
                    Slider will pass its value to <code>formatter</code>, and
                    display its value in Tooltip, and hide Tooltip when return
                    value is null
                  </td>
                  <td>value =&gt; ReactNode | null</td>
                  <td>IDENTITY</td>
                  <td>4.23.0</td>
                </tr>
              </tbody>
            </table>
            <div className="prop-header">
              <p className="props-title">Methods</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>blur()</td>
                  <td>Remove focus</td>
                  <td></td>
                </tr>
                <tr>
                  <td>focus()</td>
                  <td>Get focus</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>
        <pre>{`
<AxSlider defaultValue={50} />
<AxSlider range defaultValue={[20, 50]} />
<AxSlider defaultValue={50} vertical style={{ height: 300 }} />
<AxSlider
  defaultValue={50}
  vertical
  style={{ height: 300 }}
  disabled
/>
<AxSlider
  range
  defaultValue={[20, 50]}
  vertical
  style={{ height: 300 }}
/>
`}</pre>
        <Space>
          <Space direction="vertical" style={{ width: 300 }}>
            <AxSlider defaultValue={50} />
            <AxSlider range defaultValue={[20, 50]} />
          </Space>

          <Space style={{ width: 300, height: 300 }}>
            <AxSlider defaultValue={50} vertical style={{ height: 300 }} />
            <AxSlider
              defaultValue={50}
              vertical
              style={{ height: 300 }}
              disabled
            />
            <AxSlider
              range
              defaultValue={[20, 50]}
              vertical
              style={{ height: 300 }}
            />
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          With Input
        </AxDivider>
        <pre>{`<div style={{ display: "flex" }}>
<AxInputNumber
  min={0}
  max={this.state.range[1]}
  style={{ margin: "0 16px" }}
  value={this.state.range[0]}
  onChange={(val) =>
    this.setState({ range: [val, this.state.range[1]] })
  }
/>
<AxSlider
  range={true}
  onChange={(range) => this.setState({ range: range })}
  value={this.state.range}
  min={0}
  max={20}
  style={{ width: "350px" }}
/>
<AxInputNumber
  min={this.state.range[0]}
  max={20}
  style={{ margin: "0 16px" }}
  value={this.state.range[1]}
  onChange={(val) =>
    this.setState({ range: [this.state.range[0], val] })
  }
/>
</div>`}</pre>

        <Space>
          <div style={{ display: "flex" }}>
            <AxInputNumber
              min={0}
              max={this.state.range[1]}
              style={{ margin: "0 16px" }}
              value={this.state.range[0]}
              onChange={(val) =>
                this.setState({ range: [val, this.state.range[1]] })
              }
            />
            <AxSlider
              range={true}
              onChange={(range) => this.setState({ range: range })}
              value={this.state.range}
              min={0}
              max={20}
              style={{ width: "350px" }}
            />
            <AxInputNumber
              min={this.state.range[0]}
              max={20}
              style={{ margin: "0 16px" }}
              value={this.state.range[1]}
              onChange={(val) =>
                this.setState({ range: [this.state.range[0], val] })
              }
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column-reverse",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: 12,
            }}
          >
            <AxInputNumber
              min={0}
              max={this.state.range[1]}
              style={{ margin: "0 16px" }}
              value={this.state.range[0]}
              onChange={(val) =>
                this.setState({ range: [val, this.state.range[1]] })
              }
            />
            <AxSlider
              range={true}
              onChange={(range) => this.setState({ range: range })}
              value={this.state.range}
              style={{ height: "350px" }}
              vertical
              marks={{
                0: "0",
                10: "10",
                20: "20",
                30: "30",
                40: "40",
                50: "50",
                60: "60",
                70: "70",
                80: "80",
                90: "90",
                100: "100",
              }}
            />
            <AxInputNumber
              min={this.state.range[0]}
              max={20}
              style={{ margin: "0 16px" }}
              value={this.state.range[1]}
              onChange={(val) =>
                this.setState({ range: [this.state.range[0], val] })
              }
            />
          </div>
        </Space>
      </div>
    );
  }
}
export default Slider;
